/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { RtSystemQuantityScopeDto } from './RtSystemQuantityScopeDto';
import {
    RtSystemQuantityScopeDtoFromJSON,
    RtSystemQuantityScopeDtoFromJSONTyped,
    RtSystemQuantityScopeDtoToJSON,
} from './RtSystemQuantityScopeDto';

/**
 * 
 * @export
 * @interface TextDto
 */
export interface TextDto {
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TextDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TextDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TextDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TextDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TextDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TextDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof TextDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TextDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TextDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TextDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TextDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof TextDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TextDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof TextDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof TextDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TextDto
     */
    isUseInSetupParameter?: boolean;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof TextDto
     */
    setupScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TextDto
     */
    $type?: TextDtoTypeEnum;
}


/**
 * @export
 */
export const TextDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoTextDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.TextDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TextDtoTypeEnum = typeof TextDtoTypeEnum[keyof typeof TextDtoTypeEnum];



/**
 * Check if a given object implements the TextDto interface.
 */
export function instanceOfTextDto(value?: unknown): value is TextDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TextDtoTypeEnum)[0];
}

export function TextDtoFromJSON(json: any): TextDto {
    return TextDtoFromJSONTyped(json, false);
}

export function TextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'isUseInSetupParameter': json['isUseInSetupParameter'] == null ? undefined : json['isUseInSetupParameter'],
        'setupScope': json['setupScope'] == null ? undefined : ((json['setupScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TextDtoToJSON(value?: Omit<TextDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value['state']),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'isUseInSetupParameter': value['isUseInSetupParameter'],
        'setupScope': value['setupScope'] == null ? undefined : ((value['setupScope'] as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        '$type': value['$type'],
    });
}

